import { routes } from "./routes/routes";
import { Routes } from "react-router-dom";
import { Route } from "react-router-dom";
import RouteWrapper from "./components/RouteWrapper";
import Login from "./pages/Login";
import ComponentProvider from "./providers/ComponentProvider";

function App() {

  return (
    <ComponentProvider>
      <Routes>
        {routes.map(({ path, loggedComponent: LoggedComponent, defaultComponent: DefaultComponent, private: isPrivate }) => {
          const DefaultComp = DefaultComponent || Login;
          return (
            <Route
              key={path}
              path={path}
              element={
                <RouteWrapper
                  isPrivate={isPrivate}
                  loggedComponent={<LoggedComponent />}
                  defaultComponent={<DefaultComp />}
                />
              }
            />
          );
        })}
      </Routes>
    </ComponentProvider>
  );
};

export default App;